import React, { useState, useContext, useEffect, useRef } from "react";
import DehazeIcon from "@mui/icons-material/Dehaze";
import { useSelector, useDispatch } from "react-redux";
import {
     Chart,
     ChartSeries,
     ChartSeriesItem,
     ChartCategoryAxis,
     ChartCategoryAxisItem,
     ChartLegend,
} from "@progress/kendo-react-charts";
import { Context } from "../../../../_context/Store";
import UiSelect from "../../../_uiComponents/common/form/UiSelectDefault";
import UiDateRangePicker from "../../../_uiMocks/_uiComponents/UiDateRangePicker";
import  {getParticipantActivationSummaryDispatchDownloadRequest} from "../../../../_redux/_actions"
import {
     timeFormatUtcToLocal,
     getObjectFromArray,
     getDateRangeString,
     showCustomLoading,
} from "../../../../_helpers/support.services";
import { dashboardConstants } from "../../../../_redux/_constants";
import ExportToExcelWithApi from "../../../_uiComponents/common/ExportToExcelWithApi";
import {InnerLoader } from "../../../_uiComponents/common/UiLoadingSpinner";

export default function ParticipantActivationSummary(props) {
     const [state, dispatch] = useContext(Context);
     const actionDispatch = useDispatch();
     const [startDate, setStartDate] = useState(null);
     const [endDate, setEndDate] = useState(null);
     const [areaId, setAreaId] = useState("");
     const [exportData, setExportData] = useState(null);    
     const downloadFileName = useRef(null);

     const { dashBoardActivationSummary, areaList,dashboardParticipantActivationDownload, loader } = useSelector((state) => {
          return {
               dashBoardActivationSummary:
                    state.dashboard.dashBoardActivationSummary,
               areaList: state.dashboard.areaList,
               dashboardParticipantActivationDownload:state.dashboard.dashboardParticipantActivationDownload,
               loader: state.loading,
          };
     });

     const color = ["blue", "green", "red", "#D9D9D9"];

     const dashBoardActivationSummaryWithColor =
          dashBoardActivationSummary?.chartDataList.map((item, index) => ({
               name: item.name,
               value: item.values,
               color: color[index],
          }));

     const getData = (startDate = null, endDate = null, areaId = null) => {
          downloadFileName.current =
               "participant_activation_summary_user_" +
               getObjectFromArray(
                    props.applicationId,
                    "value",
                    dashboardConstants.userTypes,
               ).label +
               "_date_" +
               getDateRangeString(startDate, endDate) +
               "_area_" +
               getObjectFromArray(areaId, "value", [
                    {
                         value: "0",
                         label: "All",
                    },
                    ...areaList.map(function (item) {
                         return {
                              label: item.area,
                              value: item.area,
                         };
                    }),
               ]).label;
          props.getData(startDate, endDate, areaId, props.applicationId);
     };

     useEffect(()=>{
          setExportData(dashboardParticipantActivationDownload)
     },[dashboardParticipantActivationDownload])

     const fetchDataForExport = async (onDownloadComplete) => {
          try {
          actionDispatch(getParticipantActivationSummaryDispatchDownloadRequest({
                  downloadType:"activationsummary",
                  startDate,
                  endDate,
                  areaId,
                  applicationId: props.applicationId
               }));
          } catch (error) {
               onDownloadComplete(false);
              console.error("Error fetching data for export:", error);
          }
      };

     useEffect(
          function () {
               getData(startDate, endDate, areaId);
          },
          [props.applicationId],
     );

     return (
          <>
               <div className="sba-chart-top-section sb-summary-chart-top">
               {showCustomLoading(
                    [dashboardConstants.DASHBOARD_GET_PARTICIPANT_ACTIVATION_SUMMARY_REQUEST],
                    loader.pendingRequests
               ) && <InnerLoader/>}
                    <h5>Participant Activation Summary</h5>
                        <ExportToExcelWithApi 
                              name={downloadFileName.current}
                              data={exportData}
                              onDownloadClick={(onDownloadComplete) => fetchDataForExport(onDownloadComplete)}
                         />
                    <div className="sba-chart-top-select-col">
                         <UiSelect
                              options={[
                                   {
                                        value: "0",
                                        label: "All",
                                   },
                                   ...areaList.map(function (item) {
                                        return {
                                             label: item.area,
                                             value: item.area,
                                        };
                                   }),
                              ]}
                              label="Area"
                              value={areaId}
                              defaultValue={0}
                              handleChange={(value) => {
                                   getData(startDate, endDate, value);
                                   setAreaId(value);
                              }}
                         />
                    </div>
                    <div className="sba-chart-top-range-picker">
                         <UiDateRangePicker
                              onChange={(value) => {
                                   if (value[0] && value[1]) {
                                        const startDate = timeFormatUtcToLocal(
                                             value[0],
                                        );
                                        const endDate = timeFormatUtcToLocal(
                                             value[1],
                                        );
                                        setStartDate(startDate);
                                        setEndDate(endDate);

                                        getData(startDate, endDate, areaId);
                                   } else {
                                        if (!value[0] && !value[1]) {
                                             getData(null, null, areaId);
                                        }
                                   }
                              }}
                         />
                    </div>
                    <div className="sba-drag-handle">
                         <DehazeIcon />
                    </div>
               </div>
               <div
                    className={
                         state.ui_sidebar_open === true
                              ? "collapse-chart"
                              : "expand-chart"
                    }
               >
                    <Chart
                         transitions={false}
                         style={{
                              width: "100%",
                              height: "100%",
                              position: "center center",
                         }}
                    >
                         <ChartLegend
                              position="bottom"
                              orientation="horizontal"
                         />
                         <ChartCategoryAxis>
                              <ChartCategoryAxisItem
                                   labels={{
                                        rotation: "auto",
                                   }}
                                   categories={
                                        dashBoardActivationSummary?.categories
                                   }
                              />
                         </ChartCategoryAxis>

                         <ChartSeries>
                              {dashBoardActivationSummaryWithColor?.map(
                                   (item, idx) => (
                                        <ChartSeriesItem
                                             key={idx}
                                             color={item.color}
                                             type="column"
                                             tooltip={{
                                                  visible: true,
                                             }}
                                             data={item.value}
                                             name={item.name}
                                        />
                                   ),
                              )}
                         </ChartSeries>
                    </Chart>
               </div>
          </>
     );
}
